import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { Avatar, InputBase } from '@mui/material';
import { PersonOutlined, SendOutlined } from '@mui/icons-material';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import BlueTextTab from 'components/Tabs/BlueTextTab';
import noop from 'lodash';

const styles = theme => ({
  addPostContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0',
    borderLeft: `20px solid ${theme.palette.background.paper}`,
    borderTop: `30px solid ${theme.palette.background.paper}`,
    borderRight: `20px solid ${theme.palette.background.paper}`,
    borderBottom: `30px solid ${theme.palette.background.paper}`,
    borderRadius: 10,
    background: theme.palette.background.paper,
  },
  addPostContent: {
    padding: '0 20px',
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'auto',
    border: `1px solid ${theme.palette.light.darkgrey}`,
    borderRadius: 10,
    background: theme.palette.background.paper,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '& .fr-view': {
      whiteSpace: 'normal', // wraps text in froala editor
    },
    '& .fr-wrapper.show-placeholder .fr-placeholder': {
      marginTop: '14px !important',
    },
  },
  addPostAvatar: {
    color: theme.palette.common.red,
    backgroundColor: '#fff !important',
    border: `2px solid ${theme.palette.common.bluegrey}`,
    width: '30px !important',
    height: '30px !important',
  },
  addPostIcon: {
    color: theme.palette.common.bluegrey,
    fontSize: '18px !important',
  },
  addPostMessageIcon: {
    alignItems: 'center',
    marginTop: 2,
    marginRight: 10,
  },
  post: {
    padding: '10px 0 8px 0',
    overflow: 'auto',
  },

  inputWrapper: {
    flex: 1,
    display: "flex",
    alignItems: "stretch",
    position: "relative",
    background: "#fff",
    borderRadius: 12,
    padding: "8px 12px",
    marginLeft: 12,
    border: "1px solid #e0e3ea",
  },

  postInput: {
    width: '100%',
    height: '100px',
    alignItems: 'flex-start !important',
  },
  postContentColumn1: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    flexGrow: 0,
    marginRight: 16,
  },
  postContentColumn2: {
    display: 'flex',
    backgroundColor: theme.palette.light.lightgrey,
    position: 'absolute',
    bottom: 40,
    right: 60,
  },
  addButton: {
    padding: '0 10px !important',
    alignItems: 'center !important',
    backgroundColor: '#C1C7DB !important',
    borderRadius: '10px !important',
    minWidth: '40px !important',
  },
  tabContainer: {
    height: 40,
    minHeight: 40,
    backgroundColor: theme.palette.light.lightgrey,
    borderRadius: '4px 4px 0 0',
    '& button': {
      cursor: 'default',
    },
    display: 'none',
  },
  newPostContainer: {
    width: '98%',
  },
});

class NewPostBox extends Component {
  render() {
    const { classes, newPost, handleChange, onAdd } = this.props;

    return (
      <div className={classes.newPostContainer}>
        <div className={classes.addPostContainer}>
          <div className={classes.tabContainer}>
            <BlueTextTab
              tabs={['Post']}
              tabIndex={0}
              onTabChange={() => noop}
            />
          </div>
          <div className={classes.addPostMessageIcon}>
            <Avatar className={classes.addPostAvatar}>
              <PersonOutlined className={classes.addPostIcon} />
            </Avatar>
          </div>
          <div className={classes.addPostContent}>
            <div className={classes.postContentColumn1}>
              <div className={classes.post}>
                <InputBase
                  name='message'
                  value={newPost.message ? newPost.message : ''}
                  onChange={handleChange}
                  placeholder='Type your message here...'
                  className={classes.postInput}
                />
              </div>
            </div>
          </div>
          <div className={classes.postContentColumn2}>
            <PrimaryButton variant='contained' onClick={onAdd} className={classes.addButton}><SendOutlined fontSize='small' sx={{ transform: 'rotate(-45deg)' }} /></PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(NewPostBox);
